import { effect, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FbAccountService } from '@core/services/admin/fb-account.service';
import { InstagramService } from '@core/services/admin/instagram.service';
import { AUTH_SLUGS } from '@features/auth/auth.routes';
import { INTEGRATIONS_SLUGS } from '@features/settings/integrations/integrations.constants';
import { APP_SLUGS, MAIN_SLUGS } from '@routes/routes.types';
import { MESSAGING_CHANNELS } from '@shared/types/channels.types';
import { ToastrService } from 'ngx-toastr';

export const metaReconnectGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const igS = inject(InstagramService);
    const fbS = inject(FbAccountService);
    const toastr = inject(ToastrService);

    const reconnectPage = `/${APP_SLUGS.MAIN}/${MAIN_SLUGS.integrations}/${MESSAGING_CHANNELS.IG}/${INTEGRATIONS_SLUGS.connect}`;
    const loginPage = `/${APP_SLUGS.AUTH}/${AUTH_SLUGS.login}`;
    const allowed = [reconnectPage, loginPage];

    effect(() => {
        if ((igS.mustReconnect() || fbS.mustReconnect()) && !allowed.includes(state.url)) {
            toastr.error(
                'Required to continue using the app',
                'Please reconnect your Meta account'
            );
            router.navigateByUrl(reconnectPage);
        }
    });

    return true;
};
